import { PipelineEnvironment, PipelineRepository } from '@telespot/domain';

export interface CountPipelinesInput {
  searchTerm?: string;
  environmentFilter?: PipelineEnvironment;
}

export interface ICountPipelinesQuery {
  /**
   * Counts pipelines matching the optional search term and environment filter.
   * Repository errors propagate so the caller can update its error state.
   */
  execute(input: CountPipelinesInput): Promise<number>;
}

export class CountPipelinesQuery implements ICountPipelinesQuery {
  constructor(private readonly pipelineRepository: PipelineRepository) {}

  public async execute(input: CountPipelinesInput): Promise<number> {
    return this.pipelineRepository.count(input.searchTerm, input.environmentFilter);
  }
}
